import { isAndroid, isIOS } from 'mobile-bridge/functions';

export const nativeAppSettingsFunctions = {
  setSharedPreferenceBoolean: (key, value) => {
    if (isAndroid()) {
      window.androidSettings.setSharedPreferenceBoolean(key, value);
    } else if (isIOS()) {
      window.webkit.messageHandlers.native.postMessage({
        type: "SET_SHARED_PREFERENCE",
        key,
        value
      });
    }
  },

  getSharedPreferenceBoolean: (key) => {
    if (isAndroid()) {
      window.androidSettings.getSharedPreferenceBoolean(key);
    } else if (isIOS()) {
      window.webkit.messageHandlers.native.postMessage({
        type: "GET_SHARED_PREFERENCE",
        key
      });
    }
  },

  setSharedPreferenceString: (key, value) => {
    if (isAndroid()) {
      window.androidSettings.setSharedPreferenceString(key, value);
    } else if (isIOS()) {
      window.webkit.messageHandlers.native.postMessage({
        type: "SET_SHARED_PREFERENCE",
        key,
        value
      });
    }
  },

  getSharedPreferenceString: (key) => {
    if (isAndroid()) {
      window.androidSettings.getSharedPreferenceString(key);
    } else if (isIOS()) {
      window.webkit.messageHandlers.native.postMessage({
        type: "GET_SHARED_PREFERENCE",
        key
      });
    }
  },

  setSharedPreferenceInt: (key, value) => {
    if (isAndroid()) {
      window.androidSettings.setSharedPreferenceInt(key, value);
    } else if (isIOS()) {
      window.webkit.messageHandlers.native.postMessage({
        type: "SET_SHARED_PREFERENCE",
        key,
        value
      });
    }
  },

  getSharedPreferenceInt: (key) => {
    if (isAndroid()) {
      window.androidSettings.getSharedPreferenceInt(key);
    } else if (isIOS()) {
      window.webkit.messageHandlers.native.postMessage({
        type: "GET_SHARED_PREFERENCE",
        key
      });
    }
  }
};

export default nativeAppSettingsFunctions;
